import { useEffect } from "react";
import { queryKeys } from "@/constants";
import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash";
import { Project, Workbook, WorkbookTransform } from "@/models/workbook";
import { NotifyService } from "@/helpers/notify";
import recentApi from "@/services/recent.api";

interface UseGetRecentProps {
  enabledToastError?: boolean;
}
export const useGetRecent = (
  { enabledToastError = false }: UseGetRecentProps = { enabledToastError: false }
) => {
  const query = useQuery({
    queryKey: [queryKeys.recent],
    queryFn: async () => {
      const response = await recentApi.getAll();
      const workbooks: Workbook[] = isEmpty(response.data.workbooks)
        ? []
        : Object.values(response.data.workbooks).filter(
            (workbook) => workbook?.discoverable === true
          );
      const projects: Project[] = isEmpty(response.data.projects)
        ? []
        : Object.values(response.data.projects);

      return { workbooks, projects } as WorkbookTransform;
    },
  });
  useEffect(() => {
    if (query.error) {
      // eslint-disable-next-line no-console
      console.error("useGetRecent", query.error.message);
      enabledToastError && NotifyService.error(query.error.message);
    }
  }, [query.error, enabledToastError]);
  return query;
};
